module.exports = __webpack_public_path__ + "static/media/Thumbs.be70055e.db";